var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeakLouder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.025,
    height: 30.05,
    viewBox: "0 0 39.025 30.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_886",
    "data-name": "Group 886",
    transform: "translate(-3121.732 1788.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M3133.061-1788.363c.532.058,1.065.1,1.595.178a12.169,12.169,0,0,1,5.873,2.211,7.974,7.974,0,0,1,3.193,5.795c.08.8.079,1.617.112,2.426a4.655,4.655,0,0,0,.658,2.157q.762,1.33,1.432,2.712a.947.947,0,0,1-.948,1.436c-.575,0-1.15,0-1.772,0v.413c0,1.22.014,2.439-.012,3.658a4.147,4.147,0,0,1-.2,1.119,3,3,0,0,1-2.686,2.193,19.987,19.987,0,0,1-2.045.073c-.195.005-.389,0-.63,0v.348q0,2.108,0,4.217a.948.948,0,0,1-1.05,1.051q-5.989,0-11.977,0a1,1,0,0,1-.923-1.562c.389-.719.839-1.413,1.158-2.163a8.382,8.382,0,0,0-.243-6.976,15.187,15.187,0,0,0-1.059-1.951,11.544,11.544,0,0,1-1.722-5.82,17.787,17.787,0,0,1-.058-2.36,9.562,9.562,0,0,1,4.65-7.554,10.162,10.162,0,0,1,4.762-1.553,1.179,1.179,0,0,0,.194-.048Zm2.7,28.109v-.308q0-2.094,0-4.188a.971.971,0,0,1,1.108-1.114c.976,0,1.952.01,2.928-.01a1.285,1.285,0,0,0,1.469-1.263,14.72,14.72,0,0,0,.089-1.867c.016-1.141,0-2.283.027-3.424a1.087,1.087,0,0,1,.213-.527.9.9,0,0,1,.82-.361c.372,0,.745,0,1.153,0-.261-.495-.484-.939-.727-1.371a6.206,6.206,0,0,1-.83-2.627c-.049-.71-.075-1.422-.1-2.134a6.043,6.043,0,0,0-3.258-5.51,12.48,12.48,0,0,0-8.738-1.257,7.6,7.6,0,0,0-6.014,5.612,11.693,11.693,0,0,0,.12,6.162,9.525,9.525,0,0,0,1.221,2.582,14.221,14.221,0,0,1,1.7,3.773,9.883,9.883,0,0,1-.868,7.7.835.835,0,0,0-.046.138Z",
    transform: "translate(0 0)",
    fill: "#fffdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M3485.167-1658.373a12.944,12.944,0,0,1-3.46,8.759c-.427.464-.908.847-1.483.322-.592-.541-.188-1.026.22-1.493a11.064,11.064,0,0,0-.006-15.178c-.416-.47-.8-.958-.212-1.493s1.06-.142,1.485.322A12.973,12.973,0,0,1,3485.167-1658.373Z",
    transform: "translate(-324.411 -109.274)",
    fill: "#fffdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M3451.969-1629.3a8.7,8.7,0,0,1-2.23,5.734c-.387.432-.835.832-1.4.359-.594-.5-.312-.992.111-1.5a6.792,6.792,0,0,0,.029-9.181c-.409-.49-.761-.991-.172-1.5s1.063-.084,1.476.381A8.655,8.655,0,0,1,3451.969-1629.3Z",
    transform: "translate(-295.491 -138.336)",
    fill: "#fffdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M3420.588-1607.307a5.544,5.544,0,0,1-1.421,3.653c-.247.275-.532.53-.892.229-.378-.317-.2-.632.071-.954a4.327,4.327,0,0,0,.018-5.849c-.261-.312-.484-.631-.11-.956s.677-.054.94.243A5.513,5.513,0,0,1,3420.588-1607.307Z",
    transform: "translate(-268.376 -160.333)",
    fill: "#fffdfd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakLouder);
export default __webpack_public_path__ + "static/media/speak-louder.9ed2b9c2ccf77a6a03435d7d7d5bad27.svg";
export { ForwardRef as ReactComponent };